import { useState, useRef } from 'react';
import DiceLogo from './DiceLogo';

export default function VictoryView({ players, currentPlayerIndex, venueName, activePartner, onSaveToVault, onReturnToLobby }) {
  const [photoPreview, setPhotoPreview] = useState(null);
  const [trashTalk, setTrashTalk] = useState('');
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const fileInputRef = useRef(null);

  const winner = players[currentPlayerIndex];
  if (!winner) return null;

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      setPhotoPreview(URL.createObjectURL(file));
    }
  }

  async function handleSave() {
    const file = fileInputRef.current?.files[0];
    if (!file) {
      alert("Please snap a photo first!");
      return;
    }
    setSaving(true);
    try {
      await onSaveToVault(file, trashTalk.trim(), activePartner, venueName);
      setSaved(true);
      setTimeout(onReturnToLobby, 1500);
    } catch (error) {
      console.error("Error saving to vault: ", error);
      alert("Could not save your victory shot. Please try again.");
      setSaving(false);
    }
  }

  return (
    <div id="victory-view">
      <DiceLogo />
      <h1 className="victory-title">VICTORY!</h1>
      <h2 className="victory-subtitle">{winner.name} Wins!</h2>
      <p className="victory-prompt">Immortalize the moment. Snap a pic of the table.</p>

      <div className="vault-card">
        {!photoPreview && (
          <label htmlFor="camera-input" className="vault-camera-label">
            <span className="vault-camera-icon">📸</span>
            Tap to open camera
          </label>
        )}
        <input
          type="file"
          id="camera-input"
          ref={fileInputRef}
          accept="image/*"
          capture="environment"
          style={{ display: 'none' }}
          onChange={handleFileChange}
        />
        {photoPreview && (
          <img id="photo-preview" src={photoPreview} alt="Victory" />
        )}
        <input
          type="text"
          className="vault-trash-talk"
          placeholder="Add a trash talk quote..."
          value={trashTalk}
          onChange={e => setTrashTalk(e.target.value)}
        />
        <div className="vault-footer">
          <div className="vault-brand">dice dice baby.</div>
          <div className="vault-location">📍 {venueName}</div>
        </div>
      </div>

      <button
        className="btn-bank victory-save-btn"
        onClick={handleSave}
        disabled={saving || saved}
      >
        {saved ? 'Saved!' : saving ? 'Saving...' : 'Save to Vault'}
      </button>
      {!saved && (
        <button className="btn-quit" style={{ marginTop: 15 }} onClick={onReturnToLobby}>
          Back to Main Menu
        </button>
      )}
    </div>
  );
}
